"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _timeZones = require('shared/services/timeZones');

/* Rev 27 P4: the Send dialog's optional schedule: a date (YYYY-MM-DD, as
 * DateInput gives it) and a quarter-hour time, on the clock of the zone the
 * user schedules in (the browser's unless they picked another). */

/* The instant for a date field and a time in the zone, or null when that
 * time doesn't happen that day (the clocks skip it going forward; review
 * R800-35). A time that happens twice is the first. */
 const sendAt = (date, hour, minute, timeZone = _timeZones.deviceTimeZone.call(void 0, )) => {
  const [year = 0, month = 1, day = 1] = date.split('-').map(Number)
  return _timeZones.zonedInstant.call(void 0, { year, month, day, hour, minute }, timeZone)
}; exports.sendAt = sendAt

/* A time of day for TimeInput, on a fixed day with no clock change, so the
 * clock it shows and gives back never depends on today's date. */
 const clockTime = (hour, minute) => new Date(2000, 0, 1, hour, minute); exports.clockTime = clockTime

 const hasPassed = (at, now) => at.getTime() <= now; exports.hasPassed = hasPassed
